module.exports = __webpack_public_path__ + "img/square-table-2.ad88a480.png";